import { render, staticRenderFns } from "./SubHeaderLayout.vue?vue&type=template&id=7bd28bf4&scoped=true"
import script from "./SubHeaderLayout.vue?vue&type=script&lang=js"
export * from "./SubHeaderLayout.vue?vue&type=script&lang=js"
import style0 from "./SubHeaderLayout.vue?vue&type=style&index=0&id=7bd28bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd28bf4",
  null
  
)

export default component.exports